const getters = {
  getPixCode(state) {
    return state.specificFields;
  },

  getPaymentsState(state) {
    return state;
  }
};

export default getters;
